import {
  centerItemFlex,
  getRelativeFontSize,
  mediumFont,
  pureWhiteColor,
  regularFont,
  theme,
} from "../../utils/styles";

const vedazTalkStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  containerScrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  chatMainContainer: {
    display: "flex",
    justifyContent: "center",
    m: 2,
    [theme.breakpoints.down("sm")]: {
      mt: 3,
    },
  },
  chatMainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 170px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    maxWidth: "1400px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 160px)",
    },
  },
  chatSubBox: {
    height: "calc(100vh - 172px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 162px)",
    },
  },
  scrollStyle: {
    height: "calc(100vh - 285px)",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "10px",
    pb: 0,
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  header: {
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    px: 3,
    alignItems: "center",
    height: "50px",
    justifyContent: "space-between",
    display: "flex",
  },
  username: {
    ...regularFont,
    fontSize: getRelativeFontSize(7),
    color: "#FFFFFF",
    height: "100%",
    alignContent: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  textField: {
    width: "100%",
    borderRadius: "0px",
    ".MuiOutlinedInput-notchedOutline": { border: "none !important" },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 12px",
      color: "#FFFFFF",
      borderRadius: "0px",
      fontSize: getRelativeFontSize(4),
      "&::-webkit-scrollbar": {
        width: "0px",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        border: "1px solid #FFFFFF",
        background: "#282945",
      },
      "&::placeholder": {
        ...mediumFont,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderBottomRightRadius: "20px",
      borderBottomLeftRadius: "20px",
      padding: "0px 12px !important",
      "&.Mui-focused fieldset": {
        border: "none !important",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontSize: getRelativeFontSize(1),
      ...mediumFont,
    },
  },
  messageBox: {
    display: "flex",
    marginBottom: "10px",
  },
  messageBoxRight: {
    justifyContent: "flex-end",
    pr: 2,
  },
  messageBoxLeft: {
    justifyContent: "flex-start",
    pl: 2,
  },
  message: {
    padding: "10px",
    borderRadius: "10px",
    maxWidth: "60%",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    position: "relative",
    paddingRight: "95px",
  },
  messageRight: {
    backgroundColor: "#8a58cb",
    alignSelf: "flex-end",
  },
  messageLeft: {
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    alignSelf: "flex-start",
  },
  messageText: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#FFFFFF",
  },
  messageTime: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "0.75rem",
    color: "#c0c0c0",
    position: "absolute",
    bottom: "5px",
    right: "10px",
  },
  dateBox: {
    p: 0.5,
    ...centerItemFlex,
    justifySelf: "center",
    width: "fit-content",
    borderRadius: "8px",
    background: "#222222",
    marginBottom: "10px",
  },
  dateSeparator: {
    ...regularFont,
    textAlign: "center",
    color: "#ffffff",
    fontSize: getRelativeFontSize(0),
  },
  startChatMessage: {
    textAlign: "center",
    color: "#888",
    fontSize: getRelativeFontSize(3),
    marginTop: "20px",
  },
  typingIndicator: {
    color: "#65676B",
    fontSize: "18px",
    fontStyle: "italic",
    marginBottom: "10px",
    animation: "fadeInOut 1s infinite",
  },
  footer: {
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    width: "calc(100% - 19px)",
    position: "fixed",
    bottom: "8px",
    right: 0,
    display: "flex",
    justifyContent: "start",
    zIndex: 10,
    mx: 1,
  },
  newMessageDivider: {
    display: "flex",
    alignItems: "center",
    margin: "16px 0",
    "&::before, &::after": {
      content: '""',
      flex: 1,
      borderBottom: "1px solid #e0e0e0",
    },
  },
  newMessageText: {
    padding: "0 10px",
    color: "#ff4444",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  welcomeBoxWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 172px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  welcomeBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    gap: 3,
    p: 4,
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      p: 2,
    },
  },
  chatImage: {
    width: "200px",
    height: "200px",
    opacity: 0.7,
    mb: 2,
    [theme.breakpoints.down("sm")]: {
      width: "120px",
      height: "120px",
    },
  },
  welcomeHeader: {
    ...mediumFont,
    color: "#ffffff90",
    fontSize: "30px",
    textAlign: "center",
    maxWidth: "80%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  selectUserText: {
    ...regularFont,
    color: "#ffffff70",
    fontSize: "22px",
    textAlign: "center",
    maxWidth: "80%",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "17px",
    },
  },
  preferenceBtn: {
    backgroundColor: "rgb(39 26 56)",
    color: "#ffffff",
    borderRadius: "12px",
    padding: "12px 24px",
    transition: "all 0.3s ease",
    border: "1px solid #8a58cb",
    boxShadow: "0 6px 32px rgba(138, 88, 203, 0.25)",
    "&:hover": {
      backgroundColor: "rgba(138, 49, 255, 0.25)",
      transform: "scale(1.05)",
    },
  },
  preferenceBtnText: {
    ...regularFont,
    fontSize: "18px",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  nicknameText: {
    ...regularFont,
    fontSize: getRelativeFontSize(5),
    color: "#FFFFFF",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "350px",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
      maxWidth: "150px",
    },
  },
  unreadCount: {
    background: "linear-gradient(135deg, #FF6B6B 0%, #FF5252 100%)",
    color: "#FFFFFF",
    borderRadius: "10px",
    minWidth: "22px",
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: 600,
    padding: "0 6px",
    boxShadow: "0 2px 6px rgba(255, 107, 107, 0.35)",
    border: "1.5px solid rgba(255, 255, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 3px 10px rgba(255, 107, 107, 0.5)",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "20px",
      height: "20px",
      fontSize: "0.7rem",
      padding: "0 5px",
    },
  },
  nameText: {
    ...regularFont,
    fontSize: getRelativeFontSize(3),
    color: "rgba(255, 255, 255, 0.72)",
    mb: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  conversationHeaderBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: "12px",
    padding: "16px 24px",
    [theme.breakpoints.down("sm")]: {
      display: "grid",
      gap: "10px",
    },
  },
  conversationHeaderText: {
    ...mediumFont,
    color: "#8876F0",
    fontSize: getRelativeFontSize(7),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  conversationContainer: {
    display: "grid",
    gridTemplateColumns: {
      xl: "repeat(3, 1fr)",
      lg: "repeat(2, 1fr)",
      md: "repeat(2, 1fr)",
      sm: "repeat(1, 1fr)",
      xs: "repeat(1, 1fr)",
    },
    gap: 3,
  },
  userBox: {
    backgroundColor: "rgba(255, 255, 255, 0.14)",
    borderRadius: "16px",
    padding: "20px",
    transition: "transform 0.2s",
  },
  matchPercentage: {
    ...regularFont,
    backgroundColor: "#8876F0",
    color: "white",
    borderRadius: "12px",
    padding: "0px 12px",
    fontSize: "0.9rem",
    alignContent: "center",
  },
  genderBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: 2,
  },
  pageButton: {
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
  },
  rowPerPageBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(136, 118, 240, 0.1)",
    borderRadius: "8px",
    padding: "8px 16px",
    gap: 1,
  },
  genderText: {
    ...regularFont,
    backgroundColor: "rgba(136, 118, 240, 0.1)",
    color: "white",
    borderRadius: "12px",
    padding: "4px 12px",
    fontSize: "0.9rem",
    alignContent: "center",
  },
  chatIcon: {
    color: "#8876F0",
    fontSize: "28px",
    [theme.breakpoints.down("sm")]: { fontSize: "20px" },
  },
  rowPerPageSelect: {
    backgroundColor: "transparent",
    border: "none",
    color: "#8876F0",
    cursor: "pointer",
  },
  rowPerPageText: {
    ...regularFont,
    color: " rgba(255, 255, 255, 0.4)",
    fontSize: getRelativeFontSize(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  searchField: {
    width: "300px",
    borderRadius: "10px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down("sm")]: {
      width: "200px",
    },
    ".MuiOutlinedInput-notchedOutline": { border: "none !important" },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 12px",
      color: "#FFFFFF",
      borderRadius: "10px",
      fontSize: getRelativeFontSize(4),
      "&::-webkit-scrollbar": {
        width: "0px",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        border: "1px solid #FFFFFF",
        background: "#282945",
      },
      "&::placeholder": {
        ...mediumFont,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderBottomRightRadius: "20px",
      borderBottomLeftRadius: "20px",
      padding: "0px 12px !important",
      "&.Mui-focused fieldset": {
        border: "1px solid rgba(255, 255, 255, 0.14)",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontSize: getRelativeFontSize(1),
      ...mediumFont,
    },
  },
  noteText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(7),
    color: pureWhiteColor,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  tabContainer: {
    display: "flex",
    gap: 2,
    mb: 3,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: "12px",
    padding: "8px",
    [theme.breakpoints.down("sm")]: {
      gap: 1,
      padding: "4px",
    },
  },
  tabButton: {
    display: "flex",
    alignItems: "center",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: 1,
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "rgba(136, 118, 240, 0.2)",
      transform: "translateY(-1px)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px",
    },
  },
  tabText: {
    ...regularFont,
    fontSize: getRelativeFontSize(4),
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  favoriteIcon: {
    color: "#FF6B6B",
    fontSize: "26px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      color: "#FF5252",
      transform: "scale(1.15) rotate(5deg)",
      filter: "drop-shadow(0 4px 12px rgba(255, 107, 107, 0.6))",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  favoriteIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 107, 107, 0.1)",
    border: "2px solid rgba(255, 107, 107, 0.2)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      backgroundColor: "rgba(255, 107, 107, 0.2)",
      borderColor: "rgba(255, 107, 107, 0.4)",
      transform: "scale(1.05)",
      boxShadow: "0 4px 16px rgba(255, 107, 107, 0.3)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "32px",
      height: "32px",
    },
  },
  favoriteIconFilled: {
    color: "#FF6B6B",
    fontSize: "20px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    filter: "drop-shadow(0 2px 4px rgba(255, 107, 107, 0.4))",
    "&:hover": {
      color: "#FF5252",
      transform: "scale(1.1) rotate(-5deg)",
      filter: "drop-shadow(0 4px 8px rgba(255, 107, 107, 0.6))",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  favoriteIconOutline: {
    color: "rgba(255, 107, 107, 0.6)",
    fontSize: "20px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: "#FF6B6B",
      transform: "scale(1.1)",
      filter: "drop-shadow(0 2px 4px rgba(255, 107, 107, 0.4))",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },

  // Daily recommendations
  dailySection: {
    mb: 4,
  },
  dailySectionHeader: {
    display: "flex",
    alignItems: { sm: "center", xs: "flex-start" },
    flexDirection: { sm: "row", xs: "column" },
    justifyContent: "space-between",
    gap: 1,
    mb: 2,
  },
  dailyTitleBadge: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "rgba(136,118,240,0.12)",
    border: "1px solid rgba(136,118,240,0.3)",
    borderRadius: "20px",
    padding: "6px 16px",
  },
  dailySparkleIcon: {
    color: "#8876F0",
    fontSize: "18px",
    filter: "drop-shadow(0 0 5px rgba(136,118,240,0.7))",
  },
  dailySectionTitle: {
    ...mediumFont,
    color: "#8876F0",
    fontSize: getRelativeFontSize(4),
    letterSpacing: "0.5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
  dailySectionSubtitle: {
    ...regularFont,
    color: "rgba(255,255,255,0.4)",
    fontSize: getRelativeFontSize(0),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(-1),
    },
  },
  dailyGrid: {
    display: "grid",
    gridTemplateColumns: {
      xl: "repeat(3, minmax(0, 1fr))",
      lg: "repeat(3, minmax(0, 1fr))",
      md: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(1, minmax(0, 1fr))",
      xs: "repeat(1, minmax(0, 1fr))",
    },
    gap: 3,
    minWidth: 0,
    width: "100%",
  },
} as const;

// Create a style element to inject keyframes
const injectKeyframes = () => {
  // Check if keyframes are already injected
  if (document.getElementById("vedaz-talk-keyframes")) return;

  const style = document.createElement("style");
  style.id = "vedaz-talk-keyframes";
  style.textContent = `
    @keyframes fadeInOut {
      0% { opacity: 0.5; }
      50% { opacity: 1; }
      100% { opacity: 0.5; }
    }
  `;
  document.head.appendChild(style);
};

// Inject keyframes when the module loads
if (typeof document !== "undefined") {
  injectKeyframes();
}

export default vedazTalkStyles;
